module.exports = __webpack_public_path__ + "static/media/AS.6db59a9a.svg";